import {CatalogProductsCriteriaBodyRestDto, CatalogProductsExportRestDto} from "@/api/pharma-cpc-export/models";
import {CatalogProductsCriteriaBodyRestDtoModel} from "@/models/criteria/CatalogProductsCriteriaBodyRestDtoModel";

export class CatalogProductsExportRestDtoModel implements CatalogProductsExportRestDto {
    criteria: CatalogProductsCriteriaBodyRestDto;
    column_codes: string[];


    constructor(column_codes: string[], criteria: CatalogProductsCriteriaBodyRestDto) {
        this.column_codes = column_codes;
        this.criteria = criteria;
    }

    public static createWithDefaults(): CatalogProductsExportRestDtoModel {
        return new this([], CatalogProductsCriteriaBodyRestDtoModel.createWithDefaults());
    }

}
